module.exports = __webpack_public_path__ + "img/firestone_logo_nl.10bb3d75.png";